/**
 * API URL configuration for production and local.
 * App/dashboard requests use REACT_APP_API_SERVER_URL.
 */

export const getAppApiUrl = () => process.env.REACT_APP_API_SERVER_URL || '';

// getEmbedScriptSnippet lived here to build the copy-paste <script> tag for the
// Integration Manager's SDK pages. Those pages are gone — the snippet is in the
// docs (product-analytics/features/script.mdx) and the site ID is on
// Settings > Project > General — so the generator had no callers left.
// REACT_APP_ANALYTICS_SCRIPT_SRC was only ever read by it.
